// extracted by mini-css-extract-plugin
export default {"container":"gk-z","blurb":"hk-z","links":"ik-z"};